<template>
  <div class="container">
    <transition name="fade">
      <article>
        <b-card class="mt-4 p-3">
          <div class="article-header mb-3 mt-3 border-bottom">
            <h1 class="card-title">Служба поддержки</h1>
          </div>
          <div class="card-text">
            <p>Добро пожаловать в службу поддержки сервиса расчета заработной платы. На этой странице вы можете ответы на свои вопросы по работе с сервисом. Если вы не нашли ответ на интересующий вопрос, то вы можете задать его разработчику через форму ниже.</p>
            <div class="row">
              <div class="col-md-6">
                <h2>Вопрос-ответ</h2>
                <p class="text-muted">База вопросов формируется</p>
              </div>
              <div class="col-md-6">
                <h2>Задать вопрос</h2>
                <b-form-group>
                  <p class="text-muted">Все поля обязательны для заполнения. Это необходимо для того, чтобы разработчик смог оперативно связаться с вами для решения проблемы.</p>
                </b-form-group>
                <b-form-group>
                  <b-input-group size="sm" prepend="Ваше имя">
                    <b-form-input v-model="user.name"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group size="sm" prepend="Email">
                    <b-form-input v-model="user.email"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group size="sm" prepend="Телефон">
                    <b-form-input v-mask="'+7 (###) ###-##-##'" placeholder="+7 (___) ___-__-__" v-model="user.phone"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <label for="supportText">Напишите свой вопрос здесь:</label>
                  <b-textarea id="supportText" rows="5" v-model="support.question"></b-textarea>
                </b-form-group>

                <b-form-group>
                  <b-button variant="primary" size="sm" @click="sendQuestion()">Отправить вопрос</b-button>
                </b-form-group>
              </div>
            </div>
          </div>
        </b-card>
      </article>
    </transition>
  </div>
</template>


<script>
import {mapGetters} from "vuex";

export default {
  name: 'Support',
  data: function () {
    return {
      support: {
        question: ''
      }
    }
  },
  methods: {
    sendQuestion: function () {
      this.$store.commit('wait', {state: true, name: 'Отправка вопроса в службу поддержки'});
      this.$http
          .post(this.$apiold, {
            task: 'support-send-question',
            support: this.support,
            user: this.user
          })
          .then(response => {
            this.$store.commit('wait', {state: false});

            // Сообщения
            this.$store.commit('alert', response.data.messages);

          });

    },
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>


<style>

</style>
